import { z } from 'zod';
import { isoDateTime } from './common';

/**
 * emailSuppressions/{id} — the unsubscribe list.
 *
 * Written ONLY by the public `unsubscribe` Cloud Function (Admin SDK, bypasses
 * rules) when a recipient clicks the "Se désabonner" link in a campaign email.
 * The campaign audience builder excludes every address present here, so an
 * unsubscribed contact never receives another mass send.
 *
 * Doc ID is a deterministic hash of the lowercased email (so re-unsubscribing
 * is idempotent and we never store the raw address as the key). The `email`
 * field holds the readable address for the admin's suppression view.
 */
export const emailSuppressionSchema = z.object({
  email: z.string().email(),
  /** Why the address was suppressed. 'unsubscribe' for self-service opt-out. */
  reason: z.string().default('unsubscribe'),
  createdAt: isoDateTime,
});
export type EmailSuppression = z.infer<typeof emailSuppressionSchema>;
